module.exports = __webpack_public_path__ + "static/caddy-comfortline-e886a0c266455739f6f5c73d7cd4c8b2.png";